<template>
  <div id=findPass>
    <div class="logintitle">
      <img class="logoimg" src="/static/img/logo.png">
    </div>
    <div class="inputcont">
      <img class="fl headtext" src="/static/img/mobile.png">
      <input placeholder="请输入手机号"  @change="changeStatus" v-model="mobile" class="text" type="text">
    </div>
    <div class="inputcont">
      <div class="wd100">
        <img class="fl headtext" src="/static/img/yzm.png">
        <input placeholder="请输入验证码" v-model="imgCode" class="text wd65" type="text">
        <div class="fr regimgyzm" @click="getImgCode()">
          <div v-if="showStatus == false"><span>点击获取验证码</span></div>
          <img v-show="showStatus" class="imgcode" :src=imgsrc>
        </div>
      </div>
    </div>
    <div class="loginbtdiv">
    	<div class="bottomreg">点击下一步,表示您已阅读并同意
	        <a class="clrbl" @click="regprotocol()">用户注册与使用协议</a>和
	        <a class="clrbl" @click="priprotocol()">隐私保护协议</a>
        </div>
      <mt-button class="login-btn" size="large" type="primary" @click="sure()">下一步</mt-button>
      <mt-button class="loginmt10" size="large" type="default" @click="gtlogin()">我已有帐号,&nbsp;马上登录</mt-button>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui';
  import cheader from '@/components/header';
  import clogo from '@/components/logo';
  import cregtop from '@/components/regtop';
  export default {
    data () {
      return {
        mobile: '',
        imgCode: '',
        isPass: 'true',
        imgsrc: domain("_imgCodeUrl"),
        showStatus: false,
        mobileCode:""
      }
    },
    methods: {
      regprotocol:function () {
        this.$router.push('/reg/regprotocol');
      },
      priprotocol:function () {
        this.$router.push('/reg/priprotocol');
      },
      changeStatus:function () {
        this.showStatus = false;
      },
      sure: function () {
        if (this.mobile == null || this.mobile == '') {
          this.$toast("请输入手机号");
          return;
        }
        var reg = /^1[0123456789]\d{9}$/;
        if (!reg.test(this.mobile)) {
          console.log('aaa')
          this.$toast("请输入正确的手机号");
          return;
        }
        if (this.imgCode == null || this.imgCode == '') {
          this.$toast("请输入验证码");
          return;
        }
        var that = this;
        this.$http.post(
          domain("_registerNextUrl"),
          {
            'mobile': this.mobile,
            'mobileCode': this.imgCode
          },
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            if (response.body.code == '0') {
              this.$router.push({name: 'regpass', query: {mobile: that.mobile, mobileCode: that.mobileCode}});
            } else if (response.body.code == '1') {
              this.$toast('验证码错误');
              this.showStatus = false;
            } else if (response.body.code == '2') {
              this.$toast('验证码错误');
              this.showStatus = false;
            } else if (response.body.code == '10') {
              this.$toast('帐号已注册');
              this.showStatus = false;
            } else {
              this.$toast('系统错误');
              this.showStatus = false;
            }
          }, function (error) {
          })
      },
      getImgCode: function () {
        if (this.mobile == null || this.mobile == '') {
          this.$toast("请输入手机号");
          return;
        }
        var reg = /^1[0123456789]\d{9}$/;
        if (!reg.test(this.mobile)) {
          this.$toast("请输入正确的手机号");
          return;
        }
        this.imgsrc = domain("_imgCodeUrl") + "&timestamp=" + new Date() + "&mobile=" + this.mobile;
        this.showStatus = true;
      },
      gtlogin: function () {
        window.location.href="/mobile/index.html";
      }
    },
    components: {
      cheader,
      clogo,
      cregtop
    }
  }
</script>
<style>
  .headtext {
    position: absolute;
    top: 15px;
    left: 30px;
  }

  .inputcont input {
    padding-left: 50px;
  }

  .inputcont {
    position: relative;
    padding: 0 10px;
    margin-bottom: 25px;
  }

  .spwd {
    position: absolute;
    left: 100%;
    margin-left: -40px;
    top: 20px;
  }

  .inputcont .headtext {
    width: 15px;
  }

  .loginbtdiv {
    padding: 0 10px;
  }

  .bottomlogin {
    margin-top: 10px;
    padding: 0 12px;
  }

  .bottomlogin a {
    color: #7d7d7d;
  }

  .wd100 {
    width: 100%;
  }

  .wd100 .wd65 {
    width: 57%;
  }

  .clrbl {
    color: #10a0e9;
  }

  .bottomreg {
    color: #7d7d7d;
    margin: 10px auto;
  }

  .regimgyzm {
    cursor: pointer;
    border: #e5e5e5 solid 1px;
    background-color: #ffffff;
    border-radius: 4px;
    -ms-border-radius: 4px;
    -moz-border-radius: 4px;
    -o-border-radius: 4px;
    -webkit-border-radius: 4px;
    display: block;
    width: 40%;
    height: 48px;
    line-height: 48px;
    text-align: center;
  }

  .inputcont .imgcode {
    width: 100%;
    height: 48px;
  }
  .loginmt10{
    margin-top:15px;
  }
</style>



// WEBPACK FOOTER //
// src/module/register/Reg.vue